
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/world/partners",
      function () {
        return require("private-next-pages/world/partners/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/world/partners"])
      });
    }
  